import {Box, IconButton} from "@mui/material";
import CodeIcon from "@mui/icons-material/Code";
import React from "react";
import {EetsDeviceHistoryEntry} from "../../../../app/api/model/eetsDevice";
import {DeviceHistoryEntry} from "../../../../app/api/model/deviceHistory";
import {useTranslation} from "react-i18next";

export interface TextViewButtonProps {
    entry: EetsDeviceHistoryEntry | DeviceHistoryEntry;
    onOpenTextView: (text: string) => void;
}

const TextViewButton = ({onOpenTextView, entry}: TextViewButtonProps) => {
    const {t} = useTranslation();
    return (
        <Box sx={{display: "flex", alignItems: "center", justifyContent: "center"}}>
            <IconButton title={t("generic_viewText")} onClick={() => onOpenTextView(entry.information)}>
                <CodeIcon />
            </IconButton>
        </Box>
    );
};
export default TextViewButton;
